import { render, staticRenderFns } from "./customer-order-data.vue?vue&type=template&id=12009f77&scoped=true"
import script from "./customer-order-data.vue?vue&type=script&lang=ts"
export * from "./customer-order-data.vue?vue&type=script&lang=ts"
import style0 from "./customer-order-data.vue?vue&type=style&index=0&id=12009f77&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12009f77",
  null
  
)

export default component.exports